export const ROUBLE_SIGN = '\u20BD';
export const NBSP = '\u00A0';
export const DOT = '\u2022';
